import React, { type PropsWithChildren } from 'react';

import { theme } from '@garnish/constants';

import { VStack } from '../../../../../../../Stack';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingDrawerVStack = (props: Props) => {
  const { children } = props;

  return (
    <VStack dividerColor={theme.colors.LIGHT} gap={theme.spacing['12']} hasDivider>
      {children}
    </VStack>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
